import Intercom from '@intercom/messenger-js-sdk';
import { useSelector } from 'react-redux';
import { useAuth } from '../providers/AuthProvider';
import { DateTime } from 'luxon';

export default function IntercomWidget() {
  const { company } = useSelector((state) => state.company);

  const { isLoggedIn } = useAuth();
  const shouldRender =
    Boolean(import.meta.env.VITE_INTERCOM_APP_ID) && company?.service_provider?.is_master && isLoggedIn;

  const profileProps = {
    user_id: company?.owner?.id?.trim(),
    name: `${company?.owner?.name} (${company?.name})`,
    email: company?.owner?.email,
    created_at: company?.owner?.created_at
      ? DateTime.fromISO(company?.owner?.created_at).toUnixInteger()
      : DateTime.local().toUnixInteger(),
    company: company?.name,
  };
  const props = {
    app_id: import.meta.env.VITE_INTERCOM_APP_ID,
    ...(company?.id ? profileProps : {}),
  };

  if (shouldRender) {
    Intercom(props);
  }

  return null;
}
